<template>
    <div :class="preCls + 'container-padding'">
        <div :class="preCls + 'content-box'">
            <Tabs class="router-view" :animated="false" v-model="active">
                <TabPane label="直播间" :index="1" name="wRoom">
                    <Access name="wRoom">
                        <router-view v-if="active == 'wRoom'" :name="$access.aliasToUri('wRoom')"></router-view>
                    </Access>
                </TabPane>
                <TabPane label="商品库" :index="2" name="wMerch">
                    <Access name="wMerch">
                        <router-view v-if="active == 'wMerch'" :name="$access.aliasToUri('wMerch')"></router-view>
                    </Access>
                </TabPane>
            </Tabs>
        </div>
    </div>
</template>
<script>
import { Tabs, TabPane } from "ivux";
import yzyTab from "_v/common/yzy-tab"
export default {
    mixins: [yzyTab],
    components: {
        Tabs,
        TabPane,
    },
    data() {
        return {
            active: this.$cache.active || "wRoom",
        };
    },
    computed: {},
    methods: {},
};
</script>
